module.exports = __webpack_public_path__ + "img/zfbged.d20994fb.png";